/**
 * Copyright (c) 2023, Oracle and/or its affiliates
 */
/**
 * @license Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
const version = '1.0.2';
export default version;
// The second argument is not a month. It is `monthIndex` and starts from `0`.
export const releaseDate = new Date(2024, 1, 20);
/* istanbul ignore next -- @preserve */
const windowOrGlobal = typeof window === 'object' ? window : global;
/* istanbul ignore next -- @preserve */
if (windowOrGlobal.ORTL_VERSION) {
    // capture the version of ORTL loaded second
    windowOrGlobal.ORTL_VERSION_ADDITIONAL = version;
}
else {
    windowOrGlobal.ORTL_VERSION = version;
}
